<template>
  <div class="hello w10 h10">
    <!-- 加载视图 start -->
    <div v-show="loadingPage">
      <div :class="['loadingStep',isPc?'':'loadingStep2']">
        <div class="loadingNum">{{stepNum}}%</div>
        <div class="loadContent">
          <div class="title">LOADING......</div>
          <div class="stepLineBox">
            <div class="stepLine h10" :style="'width:'+stepNum+'%'"></div>
          </div>
        </div>
      </div>
      <!-- pc端的加载视频 -->
      <video v-if="isPc" class="loadingBg w10 h10" :src="src2" autoplay loop muted></video>
      <!-- 移动端的loading图 -->
      <img v-if="!isPc" class="loadingBg w10 h10" :src="src3" />
    </div>
    <!-- 加载视图 end -->
    <!-- 三维场景 start -->
    <iframe :src="src" ref="iframe" id="3d" class="dIframe" scrolling="no" frameborder="0"></iframe>
    <!-- 三维场景 end -->
    <!-- 线上展厅主体代码 start -->
    <div v-if="!loadingPage" :class="['h10','carContent',isPc?'':'carContent2']">
      <div class="moreCarBtn fl" @click="goMoreCar()">
        <img class="moreCarImg w10 h10" :src="moreCarImg" alt />
        <span class="moreCarText w10">
          查看
          <br />更多车型
        </span>
      </div>
      <div class="fr moreCarRight h10">
        <div class="carFun">
          <div
            v-if="standId ==='1'"
            :class="['funBtn',funActive === 0?'funBtnActive':'']"
            @click="changFun(0)"
          >
            <img src="../assets/image/changCol.png" alt />
            <label for>换色</label>
          </div>
          <div
            v-if="standId ==='1'"
            :class="['funBtn',funActive === 1?'funBtnActive':'']"
            @click="changFun(1)"
          >
            <img src="../assets/image/changeCar.png" alt />
            <label for>换车</label>
          </div>
          <div class="funBtn funBtn2" @click="changFun(2)">
            <img src="../assets/image/changeLink.png" alt />
            <label for>全景外观</label>
          </div>
          <div class="funBtn funBtn2" @click="changFun(3)">
            <img src="../assets/image/changeLink.png" alt />
            <label for>全景内饰</label>
          </div>
        </div>
        <div v-if="standId ==='1'&&funType == 'car'" class="carModel">
          <el-carousel
            class="screenBoxContent w10 h10"
            :loop="false"
            :autoplay="false"
            arrow="always"
          >
            <el-carousel-item>
              <div
                v-for="item in contentList"
                :class="['modelBtn',carId==item.id?'modelBtnActive':'']"
                :key="item.id"
                @click="changeCar(item.id,item)"
              >{{item.carModel}}</div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-if="standId ==='1'&& funType == 'color'" class="colModel">
          <el-carousel
            class="screenBoxContent w10 h10"
            :loop="false"
            :autoplay="false"
            arrow="always"
          >
            <el-carousel-item>
              <div
                :class="['colorBtn',colActive==item.id?'colorBtnActive':'']"
                v-for="item in contentList2"
                @click="changeCol(item.id,item)"
                :key="item.id"
              >
                <img class="w10 h10" :src="item.url" alt />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 线上展厅主体代码 end -->
    <!-- 线上展厅左侧栏功能 start -->
    <left-nav v-if="!loadingPage"></left-nav>
    <!-- 线上展厅左侧栏功能 end -->
    <!-- 线上展厅小程序弹窗 start -->
    <el-dialog
      v-if="isPc"
      class="xcxDialog"
      title
      :visible.sync="xcxVisible"
      :before-close="handleClose"
    ></el-dialog>
    <!-- 线上展厅小程序弹窗 end -->
  </div>
</template>

<script>
import leftNav from "../components/leftNav.vue";

export default {
  name: "iveco",

  components: {
    leftNav
  },
  data() {
    return {
      stepNum: "3", //加载百分比
      src: "../../3d/static/public/3d/index.html", //三维场景页面 服务器环境路径static前加上dist
      // src: "../../static/public/3d/index.html", //三维场景页面 服务器环境路径static前加上dist
      src2: require("../../static/public/3d/res/imgs/joystick/loading.mp4"),
      src3: require("../../static/public/3d/res/imgs/joystick/loading.png"),
      number: "",
      iframeWin: {},
      loadingPage: true, //三维加载状态
      contentList: [
        //当前选中车位车型List
      ],
      funActive: "", //功能模块选中状态
      carActive: "", //换车选中状态
      colActive: "", //换色选中状态
      xcxVisible: false, //小程序二维码的显示隐藏
      contentList2: [
        //当前选中车辆色卡图片
      ],
      moreCarImg: require("../assets/image/moreCar.png"),
      funType: "", //下侧导航栏点击状态
      standId: "1", //当前视角展位的Id
      standIndex: "1", //一号展位的车位下标
      testData: [], //初始展位信息
      baseImg: [], //基础图片配置信息 合作伙伴。。。
      defaultCar: [], //默认车辆
      outLink: "", // 当前全景外观链接
      innerLink: "", // 当前全景内饰链接
      carId: "", //当前视角车型的Id
      carId1: "", //当前一号车位选中Id
      carId12: "" //当前二号车位选中Id
    };
  },
  mounted() {
    //判断是否为移动端
    this.mobileView();
    //加载模型前提
    this.modelSet();
    //获取基础配置图
    this.getBaseImg();
    //获取默认展位信息
    this.getShowStandInfo();
    //获取所有展位的默认车型
    this.getDefaultCar();
    //获取一号展位的左侧车型
    this.getStandCar(this.standId); 
  },
  methods: {
    //加载模型前提
    modelSet() {
      // 将vue中的方法赋值给window
      window.getMessage = this.getMessage;
      window.addEventListener("message", this.handleMessage);
      this.iframeWin = this.$refs.iframe.contentWindow;
      this.msgType = {
        //初始操作
        init_scene: "01", //初始场景
        init_stand: "02", //初始展位信息
        init_progress: "03", //进度条
        init_defaultcar: "04", //初始默认汽车信息
        //切换车型
        car_switchType: "10", //切换车型
        car_switchColor: "11", //切换车颜色
        car_lookat: "12", //切换视角
        //事件
        event_click_car: "21", //点击车辆回调
        event_minDis_car: "22", //离视角最近汽车
        event_click_xcx: "23", //点击小程序
        event_click_dibiao: "24", //点击地标
        //模型
        model_changeTexture: "31", //修改其他未绑定模型图片
        //返回事件
        res_error: "-1",
        res_ok: "00"
      };

      //注意： 如果本身iframe嵌套的盒子有延迟 则下面判断最好也加延迟
      let that = this;
      const iframe = document.getElementById("3d");
      // 处理兼容行问题
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function() {
          // console.log("加载完成");
          that.initScene();
        });
      } else {
        iframe.onload = function() {
          // console.log("加载完成");
          that.initScene();
        };
      }
    },
    //获取基础配置图
    getBaseImg() {
      this.$fetch("app/autoShowArea/selectAll").then(res => {
        this.baseImg = res.data.data;
        let objName = ["", "TP_16", "TP_17", "TP_13", "TP_08"];
        this.baseImg.map(v => {
          //判断模型ID配置图片
          v.objName = objName[v.id];
          return;
        });
      });
    },
    //获取所有展位的默认车型
    getDefaultCar() {
      this.$fetch("/app/autoShow/defaultCarViews").then(res => {
        //  this.msgType.init_stand; //消息类型
        let arr = [];
        res.data.map((v, index) => {
          if (v.standId == 1) {
            let obj = {
              url: v.carPicUrl,
              id: v.carId,
              enableRotate: "true",
              local: v.local,
              outLink: v.outLink,
              innerLink: v.inLink
            };
            if (v.local != 1) {
              arr[1] = obj;
              return;
            }
            this.innerLink = v.inLink;
            this.outLink = v.outLink;
            this.carId = v.carId;
            this.colActive = v.skId;
            arr[0] = obj;
          } else {
            this.defaultCar.push({
              stand: v.standId,
              cars: [
                {
                  id: v.carId,
                  url: v.carPicUrl,
                  enableRotate: "true",
                  local: v.local,
                  outLink: v.outLink,
                  innerLink: v.inLink
                }
              ]
            });
          }
          if (res.data.length - 1 == index) {
            this.defaultCar.unshift({
              stand: "1",
              cars: arr
            });
          }
        });
      });
    },

    //获取默认展位信息
    getShowStandInfo() {
      this.$fetch("/app/autoShowStand/queryAll").then(res => {
        this.testData = res.data.data;
        // // console.log(this.testData);
        //获取八号展位的配图
        res.data.data.map(v => {
          if (v.id == 8) {
            v.urlData.map(i => {
              if (i.type == 1) {
                this.baseImg.push({
                  objName: "TP_14",
                  url: i.url
                });
              }
            });
          }
        });
      });
    },
    //换车换色图片预加载
    imgOnLoad() {
      let carImgArr = [];
      this.$fetch("/app/autoShow/carDataViews", {
        standId: 1,
        local: ""
      }).then(res => {
        // // console.log(res.data);
        res.data.map(v => {
          v.carData.map(item => {
            carImgArr.push(item.picData[0].url);
          });
        });
        // // console.log(carImgArr);
        carImgArr.forEach((item, index) => {
          // // console.log(index);
          const image = new Image();
          image.src = item;
          image.onload = () => {};
        });
      });
    },
    //换车按钮{}
    changeCar(id, item) {
      // id=>车辆Id
      //item=> 车辆主体信息
      this.carId = id;
      // // console.log(item);
      this.contentList2 = item.carData;
      let mainUrl = "";
      this.outLink = item.outLink;
      this.innerLink = item.inLink;
      let data = {};
      item.carData.map(v => {
        if (v.dataType === "1") {
          this.colActive = v.id;
          data = {
            type: this.msgType.car_switchType,
            stand: "1",
            id: item.id,
            local: item.local,
            colorid: v.id,
            enableRotate: true,
            url: v.picData[0].url,
            innerLink: item.inLink,
            outLink:item.outLink
          };
          //替换模型场景中的车辆信息
          this.defaultCar[0].cars[item.local - 1] = data;
          this.switchCarType(data);
        }
      });
      //  this.standId
    },
    //换色按钮{}
    changeCol(id, item) {
      // id=>色卡ID
      // item=>色卡主体
      this.colActive = id;
      // // console.log(item);
      this.carId = item.pid;
      let data = {
        type: this.msgType.car_switchColor,
        stand: "1",
        id: item.pid,
        local: this.standIndex,
        colorid: item.id,
        url: item.picData[0].url
      };
      data.enableRotate = item.dataType === "1";
      // // console.log(item, data);
      this.switchCarColor(data);
    },
    //切换车辆视角
    lookAtCar() {
      let type = this.msgType.car_lookat; //消息类型
      let data = {
        type: type,
        stand: "1",
        index: "2"
      }; //index:默认1， 针对展位一，第二个车index=2
      this.sendMsgTo3D(data);
    },
    //更换历史墙，合作伙伴...
    switchOtherTexture() {
      let type = this.msgType.model_changeTexture; //消息类型
      let data = {
        type: type,
        datas: this.baseImg
      };
      this.sendMsgTo3D(data);
    },
    //切换小程序
    lookAtXcx() {
      let type = this.msgType.event_click_xcx; //消息类型
      let data = {
        type: type
      }; //index:默认1， 针对展位一，第二个车index=2
      this.sendMsgTo3D(data);
    },
    //关闭小程序
    handleClose() {
      this.xcxVisible = false;
    },
    // 逐步获取展位信息图片
    getMessage(data) {
      if (data.type === 1) {
        this.initStand(); //加载展位
        return;
      }
      if (data.type === 2) {
        this.switchOtherTexture(); //加载其他模型图片
        return;
      }
      if (data.type === 4) {
        this.initDefaultCar(); //加载默认车辆
        return;
      }
      // console.log(data);
    },
    // 外部vue向iframe内部传数据
    sendMsgTo3D(data) {
      this.iframeWin.postMessage(data, "*");
      return true;
    },
    //加载场景
    initScene() {
      this.stepNum = 10;
      let t = this;
      let type = this.msgType.init_scene; //消息类型
      let data = {
        type: type
      };
      t.sendMsgTo3D(data);
    },
    //加载展位配置
    initStand() {
      this.stepNum = 30;
      this.sendMsgTo3D({
        type: this.msgType.init_stand,
        standData: this.testData
      });
      //  this.msgType.init_stand; //消息类型
    },

    //加载车型
    initDefaultCar() {
      this.stepNum = 70;
      //虚拟增加百分比
      let timer = setInterval(() => {
        if (this.stepNum < 99) {
          // // console.log("增加进度");
          this.stepNum++;
        } else {
          // // console.log("清除定时器");
          clearInterval(timer);
        }
      }, 5000);
      let type = this.msgType.init_defaultcar; //消息类型
      let data = {
        type: type,
        cars: this.defaultCar
      };
      // // console.log(this.defaultCar);
      setTimeout(() => {
        this.sendMsgTo3D(data);
      }, 100);
    },
    //三维换车功能
    switchCarType(data) {
      let type = this.msgType.car_switchType; //消息类型
      this.sendMsgTo3D(data);
    },
    //三维换色
    switchCarColor(data) {
      this.sendMsgTo3D(data);
    },

    // 根据上面制定的结构来解析iframe内部发回来的数据
    handleMessage(event) {
      //// console.log('vue获取数据原生Html数据---：',event.data);
      if (!event.data.params) {
        return;
      }
      if (event.data.type == this.msgType.res_ok) {
        if (event.data.params.type == this.msgType.init_scene) {
          this.status1 = true;
          window.getMessage({
            type: 1,
            txt: "场景加载完成"
          });
          // alert('场景')
        } else if (event.data.params.type == this.msgType.model_changeTexture) {
          // console.log("修改模型图片完成");
          window.getMessage({
            type: 4,
            txt: "模型图片加载完成"
          });
        } else if (event.data.params.type == this.msgType.init_stand) {
          window.getMessage({
            type: 2,
            txt: "展位加载完成"
          });
        } else if (event.data.params.type == this.msgType.init_progress) {
        } else if (event.data.params.type == this.msgType.init_defaultcar) {
          window.getMessage({
            type: 3,
            txt: "车位加载完成"
          });
          this.stepNum = 100;
          setTimeout(() => {
            this.loadingPage = false;
          }, 2000);
          this.imgOnLoad();
        } else if (event.data.params.type == this.msgType.car_switchType) {
          // // console.log("切换车辆型号完成");
        } else if (event.data.params.type == this.msgType.car_switchColor) {
          // // console.log("切换车辆颜色完成");
        } else if (event.data.params.type == this.msgType.event_click_car) {
          // // console.log(
          //   "点击了,展位:" +
          //     event.data.params.stand +
          //     "，车辆id:" +
          //     event.data.params.id,
          //   event.data
          // );
          this.standIndex = event.data.params.local;
          // // console.log(event.data.params);
          this.carId = event.data.params.id;
          this.standId = event.data.params.stand;
          this.getStandCar(this.standId);
          this.clickStandCar(this.standId, this.standIndex);
        } else if (event.data.params.type == this.msgType.event_minDis_car) {
          // console.log(
          //   "最近汽车,展位:" +
          //     event.data.params.stand +
          //     "，车辆id:" +
          //     event.data.params.id
          // );
        } else if (event.data.params.type == this.msgType.car_lookat) {
          // console.log("视角切换完成");
        } else if (event.data.params.type == this.msgType.event_click_xcx) {
          // console.log("点击小程序" + event.data.params.name);
          if (this.isPc) {
            // console.log("Pc端打开二维码");
            this.xcxVisible = true;
          } else {
            window.open("https://yjrv.naveco.com.cn/#/");
          }
        } else if (event.data.params.type == this.msgType.event_click_dibiao) {
          // console.log("点击地标名称:" + event.data.params.name);
          this.standId = event.data.params.name.slice(-1);
          // console.log(this.standId);
          this.standIndex = this.standId == 1 ? 1 : 0;
          this.getStandCar(this.standId);
          this.clickStandCar(this.standId, this.standIndex);
        }
      } else {
        // console.log("error:", event.data);
      }
    },
    //判断是否移动端
    isMobel() {
      //是否为移动端
      let userAgentInfo = navigator.userAgent;
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          return true;
        }
      }
      return false;
    },
    mobileView() {
      //移动端横屏
      if (this.isMobel()) {
        // isPC=>是否为pc端
        this.$store.dispatch("setIsPC", false);
        let iframe = document.getElementById("3d");
        iframe.style.transformOrigin = "left top";
        iframe.style.transform = "rotate(90deg)";
        // // console.log(document.body.clientWidth);
        // // console.log(document.body.clientHeight);
        setTimeout(() => {
          iframe.style.width = document.documentElement.clientHeight + "px";
          iframe.style.height = document.documentElement.clientWidth + "px";
          iframe.style.top = "0px";
          iframe.style.left = "100%";
        }, 100);
      } else {
        this.$store.dispatch("setIsPC", true);
        let iframe = document.getElementById("3d");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.top = "0px";
        iframe.style.left = "0px";
      }
    },
    //更换展位功能按钮数据
    getStandCar(id) {
      // console.log(id);

      if (id != 1) {
        this.standIndex = 0;
      }
      // console.log(this.carId);
      this.$fetch("/app/autoShow/carDataViews", {
        standId: this.standId,
        local: this.standIndex
      }).then(res => {
        this.contentList = res.data;
        res.data.map(v => {
          this.contentList2 =
            v.id == this.carId ? v.carData : this.contentList2;
        });
      });
    },
    //更改全局外观和全局内饰
    clickStandCar(index, local) {
      let carList =
        index != "1"
          ? this.defaultCar[index - 1].cars[0]
          : this.defaultCar[index - 1].cars[local - 1];
      // console.log(carList);
      this.outLink = carList.outLink;
      this.innerLink = carList.innerLink;
    },
    //切换功能方法
    changFun(n) {
      // n=>{0:换色，1：换车，2：外链接，3：内部链接}
      let backUrl =  'https://vr.naveco.com.cn/#/digital';  
        if(this.isPc){
          backUrl = "https://www.naveco.com.cn/exhibition";
        }
      if (n == 2) {
        window.open(this.outLink+'&backUrl='+encodeURIComponent(backUrl));
        return;
      }
      if (n == 3) {
        window.open(this.innerLink+'&backUrl='+encodeURIComponent(backUrl));
        return;
      }
      this.funActive = n;
      this.funType = n == 0 ? "color" : "car";
    },
    //查看更多车型
    goMoreCar() {
      console.log(this.isPc);
      if(this.isPc){
        window.open("https://www.naveco.com.cn/exhibition");
      }else{
        window.open('https://vr.naveco.com.cn/#/digital')
      }
    }
  },
  computed: {
    isPc() {
      // true PC
      // false 大屏
      return this.$store.getters.isPC;
    }
  }
};
</script>

<style scoped>
@import url("../assets/css/index.css");
</style>



// WEBPACK FOOTER //
// src/components/index.vue